import { z } from 'zod';
import { UUIDSchema } from './common';
export const TextSnippetSchema = z.object({
    uuid: UUIDSchema,
    topic: z.string(),
    subtopic: z.string().optional(),
    title: z.string(),
    content: z.string(),
});
const TextSnippetListShape = {
    text_snippets: TextSnippetSchema.array(),
};
export const TextSnippetListSchema = z.object(TextSnippetListShape);
